export default __webpack_public_path__ + "static/fighting-coronavirus-innovations-77d17497034c6575986555882a155916.jpg";